// Libraries
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'helpers/proptypes'
import { withTranslation } from 'react-i18next'
// Components
import { Form, Button } from 'semantic-ui-react'
import { SearchInput } from 'components/inputs'
// Selectors
import { getLocation } from 'redux/reducers/router'
import { Link } from 'react-router'

const mapStateToProps = (state) => ({ location: getLocation(state) })

class _CampaignSearchForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    location: PropTypes.immutable.map,
  }

  static defaultProps = {
    location: undefined,
  }

  static contextTypes = { router: PropTypes.object }

  UNSAFE_componentWillMount() {
    return this.updateStateFromLocation(this.props)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.location.equals(this.props.location)) return this.updateStateFromLocation(nextProps)
  }

  updateStateFromLocation(props) {
    return this.setState({
      search: props.location.getIn(['query', 'search'], ''),
    })
  }

  updateQuery(query = this.state) {
    return this.context.router.push(this.props.location.mergeIn(['query'], { ...query, offset: 0 }).toJS())
  }

  clearFilters() {
    return this.setState({ search: '' }, () => this.updateQuery())
  }

  handleSubmit(e) {
    e.preventDefault()
    return this.updateQuery()
  }

  render() {
    const { t } = this.props
    return (
      <Form onSubmit={this.handleSubmit.bind(this)} style={{ marginBottom: '1em' }} autoComplete='off'>
        <Form.Group widths='equal'>
          <Form.Field>
            <label>{t('Campaigns::Search')}</label>
            <SearchInput
              placeholder={t('Campaigns::Title / Code / Email')}
              fluid
              icon='search'
              iconPosition='left'
              value={this.state.search}
              onChange={(value) => this.setState({ search: value })}
            />
          </Form.Field>

          <Form.Field>
            <label>&nbsp;</label>
            <Button type='submit'>{t('Campaigns::Search')}</Button>

            <Button basic onClick={this.clearFilters}>
              {t('Campaigns::Clear filters')}
            </Button>

            <Button as={Link} to='/campaigns/add' primary style={{ transform: 'translateX(15px)' }}>
              {t('Campaigns::Create new')}
            </Button>
          </Form.Field>
        </Form.Group>
      </Form>
    )
  }
}

export const CampaignSearchForm = withTranslation('common')(connect(mapStateToProps)(_CampaignSearchForm))
